export const normalize = (val: string) => {
  let number = val;
  const digits = number.replace(/[^\d]/g, '');
  if (!digits.length) return '';
  number = '';
  number += digits.slice(0, 2);
  if (digits.length >= 3) number += '/';
  number += digits.slice(2, 4);
  if (digits.length >= 5) number += '/';
  number += digits.slice(4, 8);
  return number;
};
